var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZavi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0607 5.93934C15.7794 5.65804 15.3978 5.5 15 5.5H5C4.60218 5.5 4.22064 5.65804 3.93934 5.93934C3.65804 6.22064 3.5 6.60218 3.5 7V17C3.5 17.3978 3.65804 17.7794 3.93934 18.0607C4.22064 18.342 4.60218 18.5 5 18.5H15C15.3978 18.5 15.7794 18.342 16.0607 18.0607C16.342 17.7794 16.5 17.3978 16.5 17V14.02V10.02V7C16.5 6.60218 16.342 6.22064 16.0607 5.93934ZM18 8.81989V7C18 6.20435 17.6839 5.44129 17.1213 4.87868C16.5587 4.31607 15.7956 4 15 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H15C15.7956 20 16.5587 19.6839 17.1213 19.1213C17.6839 18.5587 18 17.7956 18 17V15.2201L20.18 16.29C20.3582 16.3857 20.5568 16.4371 20.759 16.4399C20.756 16.44 20.753 16.44 20.75 16.44H20.77C20.7663 16.44 20.7627 16.44 20.759 16.4399C21.0864 16.435 21.3993 16.3027 21.631 16.071C21.8649 15.8372 21.9974 15.5207 22 15.19V8.85002C22.0085 8.62937 21.9583 8.41043 21.8547 8.21545C21.751 8.02048 21.5976 7.85644 21.41 7.74002C21.2257 7.63478 21.0172 7.57944 20.805 7.57944C20.5928 7.57944 20.3843 7.63478 20.2 7.74002L18 8.81989ZM18 10.49V13.55L20.52 14.79V9.25001L18 10.49Z",
    fill: "#081B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZavi);
export default __webpack_public_path__ + "static/media/Zavi.5a17b45c50e0059f805c2b08c3d3a0cb.svg";
export { ForwardRef as ReactComponent };